<script lang="ts">
	import { menu } from '@tools/Menu.svelte';
	import { slide } from 'svelte/transition';
	import { SearchSections } from '@comp/section';
	import { sharedConfig } from '$lib/animations';
	import { trackClickedSearch } from '@tools/tracking/TrackSearch';
	import NoResult from './NoResult.svelte';

	let {
		query,
		results = [],
		loading = false
	}: {
		query: string;
		results?: any[];
		loading?: boolean;
	} = $props();

	let hasResults = $derived(results.length > 0);

	const handleClick = (e: MouseEvent) => {
		const target = e.target as HTMLElement | null;
		if (!target || target.tagName.toLowerCase() !== 'a') return;
		trackClickedSearch({
			query,
			path: target.getAttribute('href') || ''
		});
	};

	// $inspect(query);
</script>

{#if menu.isSearching}
	<!-- svelte-ignore a11y_click_events_have_key_events -->
	<!-- svelte-ignore a11y_no_static_element_interactions -->
	<section transition:slide={sharedConfig} onclick={handleClick}>
		{#if loading}{:else if !hasResults && query.length > 2}
			<NoResult />
		{:else}
			<SearchSections blocks={results} caller={`SearchSections/${query}`} />
		{/if}
	</section>
{/if}

<style lang="scss">
	section {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: calc(var(--vh) - var(--nav-height));
		background-color: $colorBackground;
		z-index: 100;
		padding: $gap6 var(--gutter);
		overflow-y: auto;
		overscroll-behavior: contain;
		scrollbar-width: thin;
		display: flex;
		flex-direction: column;
		gap: $gap5;

		@include sm {
			display: grid;
			grid-template-columns: 1fr 1fr;
			grid-auto-rows: max-content;
			grid-gap: $gap6 var(--gap);
			grid-auto-flow: row dense;
		}

		@include xxl {
			grid-template-columns: 1fr 1fr 1fr 1fr;
		}
	}
</style>
